import { env } from '../config.js';

export async function createChart(token, type, name, partId, chartData) {
    let data = {type: type, name: name, partId: partId};
    if (type === "OUTLIER"){
        data.outlierParams = chartData;
    } else if (type === "HISTOGRAM"){
        data.histogramParams = chartData;
    } else if (type === "BOXPLOT") {
        data.boxplotParams = chartData;
    } else if (type === "TWOAFC") {
        data.twoAfcParams = chartData;
    }

    const response = await fetch(env.BACKEND_URL + '/charts',
    {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        body: JSON.stringify(data)
    });
    return await response;
}

export async function setDashboardChart(token, chartId) {
    const response = await fetch(env.BACKEND_URL + '/charts/dashboard/' + chartId,
    {
        method: 'POST',
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
    return await response;
}

export async function deleteChart(token, id) {
    const response = await fetch(env.BACKEND_URL + '/charts/' + id,
    {
        method: 'DELETE',
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
    return await response;
}

export async function removeDashboardChart(token, chartId) {
    const response = await fetch(env.BACKEND_URL + '/charts/dashboard/' + chartId,
    {
        method: 'DELETE',
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
    return await response;
}
